import { useEffect } from 'react';

import relinkMissingFontsOperation from 'editor/src/store/fonts/operation/relinkMissingFontsOperation';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

// Runs on both inputs: the font may be uploaded after the design loads, or a design (another
// variant, an undo) may arrive naming a font that is already uploaded.
function useMissingFontRelinkWatcher() {
  const dispatch = useDispatch();
  const designData = useSelector((state) => state.design.designData);
  const uploadedFonts = useSelector((state) => state.fonts.uploadedFonts);

  useEffect(() => {
    dispatch(relinkMissingFontsOperation());
  }, [designData, uploadedFonts]);
}

export default useMissingFontRelinkWatcher;
